/**
 * package.json sits outside src/, so the @/* alias cannot reach it.
 */
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import packageJson from "../../package.json";

export const IS_PRODUCTION = import.meta.env.VITE_ENV === "production";
const IS_DEVLOPMENT = import.meta.env.VITE_ENV === "development";
export const IS_LOCAL = !IS_DEVLOPMENT && !IS_PRODUCTION;

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_PUBLIC_GOOGLE_CLIENT_ID;

export const APP_VERSION = packageJson.version;
